<template>
  <div class="content">
    <h1 class="has-text-centered">Konverter</h1>
    <div class="box">
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered is-size-7-mobile">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-ohms-law'}" class="inherited">
                  <div class="p-2">
                    Zahlensysteme
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'formulas-dc'}" class="inherited">
                  <div class="p-2">
                    Temperatur
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'formulas-dc'}" class="inherited">
                  <div class="p-2">
                    Bit - Byte
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'formulas-dc'}" class="inherited">
                  <div class="p-2">
                    Grad - Radiant
                  </div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-converter',
  metaInfo: {
    title: 'Der digitale Begleiter für deine Projekte',
    meta: [
      {
        name: 'description',
        content: 'Hier findest du Rechner, Tabellen, Formeln und mehr. Einfach im Browser oder als App für Desktop und Smartphone.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Elektrotechnik-Rechner.at', route: 'start' })
  }
}
</script>
